module.exports = __webpack_public_path__ + "img/uniswap.093eb4f4.svg";